import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    timeout: { type: Number, default: 4000 }
  }

  connect() {
    this.autoDismiss()
  }

  autoDismiss() {
    if (this.timeoutValue <= 0) return

    this.timeout = window.setTimeout(() => {
      this.element.classList.add("opacity-0", "transition", "duration-300")
      window.setTimeout(() => this.element.remove(), 300)
    }, this.timeoutValue)
  }

  disconnect() {
    if (this.timeout) {
      window.clearTimeout(this.timeout)
    }
  }
}
